// test1459
(1459 && 0);
